export const Pulse = () => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.45703 9.79153H3.74992C4.49008 9.79153 5.14157 9.30339 5.34948 8.59303L7.09398 2.63263C7.2113 2.23179 7.77977 2.23362 7.89451 2.63521L12.0933 17.3311C12.2088 17.7354 12.7823 17.7336 12.8953 17.3287L14.6586 11.0102C14.8596 10.2898 15.516 9.79153 16.2639 9.79153H18.5404"
      stroke="#7A7A83"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default Pulse
